import { useEffect, useState } from "react";
import { Cookie, X } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const KEY = "ww_cookie_consent_v1";

export default function CookieConsent() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShown(true);
    }, 900);
    return () => clearTimeout(t);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    setShown(false);
  };

  if (!shown) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 p-4 animate-fade-up" data-testid="cookie-banner" role="dialog" aria-label="Cookie preferences">
      <div className="max-w-3xl mx-auto bg-cream border border-border rounded-2xl shadow-hero p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-coral-50 border border-coral-100 grid place-items-center shrink-0">
          <Cookie size={20} weight="duotone" className="text-coral-700" />
        </div>
        <div className="flex-1 text-sm text-ink/80 leading-relaxed">
          <span className="font-display text-base text-ink block">A gentle note about cookies.</span>
          Wingwomen uses essential cookies to keep you signed in, and analytics cookies to
          understand how the circle grows. Nothing is sold, ever. See our{" "}
          <Link to="/terms#privacy" className="underline underline-offset-4 text-coral-700 hover:text-coral-600">
            Privacy & HIPAA policy
          </Link>.
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button onClick={() => choose("declined")}
                  data-testid="cookie-decline"
                  className="text-xs px-3 py-2 rounded-full border border-border hover:border-ink transition-colors">
            Essential only
          </button>
          <button onClick={() => choose("accepted")}
                  data-testid="cookie-accept"
                  className="text-xs px-4 py-2 rounded-full bg-coral text-white hover:bg-coral-600 transition-colors">
            Accept all
          </button>
          <button onClick={() => choose("dismissed")}
                  data-testid="cookie-close"
                  aria-label="Close"
                  className="p-1.5 rounded-full hover:bg-muted transition-colors">
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
